import { Filter } from '@iot-platform/models/common';
import { GroupedFilter } from '../models';
import { requiresValue } from './operator-mapping.helper';

export function groupFiltersByFieldAndOperator(filters: Filter[], getFieldLabel: (criteriaKey: string) => string | null): GroupedFilter[] {
  const groups = new Map<string, GroupedFilter>();

  filters.forEach((filter, index) => {
    if (!filter.criteriaKey || !filter.criteriaOperator) {
      console.warn('Filter missing required properties (criteriaKey or criteriaOperator):', filter);
      return;
    }

    const groupKey = `${filter.criteriaKey}_${filter.criteriaOperator}`;

    if (!groups.has(groupKey)) {
      const fieldLabel = filter.criteriaLabel || getFieldLabel(filter.criteriaKey) || filter.criteriaKey;

      groups.set(groupKey, {
        fieldLabel,
        fieldKey: filter.criteriaKey,
        operator: filter.criteriaOperator,
        filters: []
      });
    }

    const group = groups.get(groupKey);
    if (group && requiresValue(group.operator)) {
      group.filters.push({ filter, index });
    }
  });

  return Array.from(groups.values());
}
